import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { useTabBehavior } from '../shared';
import { TabsContainer, FilterTabUl, FilterTabHeader, getFiltertabThemeConfig } from '../styles';

// adapted from https://inclusive-components.design/tabbed-interfaces/
var FilterTabs = function FilterTabs(_ref) {
  var id = _ref.id,
      tabs = _ref.tabs,
      activeTabIndex = _ref.activeTabIndex,
      onChangeIndex = _ref.onChangeIndex,
      tabPanel = _ref.tabPanel,
      className = _ref.className,
      theme = _ref.theme,
      dataTest = _ref['data-test'];

  var _useTabBehavior = useTabBehavior(id, activeTabIndex, onChangeIndex, tabs, 'horizontal'),
      onTabKeyDown = _useTabBehavior.onTabKeyDown,
      onTabClick = _useTabBehavior.onTabClick;

  var componentTheme = useComponentTheme({
    name: 'FilterTabs',
    theme: getFiltertabThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(TabsContainer, {
    className: className,
    "data-test": dataTest,
    orientation: "horizontal"
  }, /*#__PURE__*/React.createElement(FilterTabUl, {
    id: id,
    role: "group",
    customTheme: componentTheme
  }, tabs.map(function (tab, index) {
    var isActive = index === activeTabIndex;
    return /*#__PURE__*/React.createElement("li", {
      role: "presentation",
      key: index
    }, /*#__PURE__*/React.createElement(FilterTabHeader, {
      id: "".concat(id, "_tabheader_").concat(index),
      "data-index": index,
      onClick: onTabClick,
      onKeyDown: onTabKeyDown,
      tabIndex: isActive ? 0 : -1,
      "aria-selected": isActive ? true : undefined,
      customTheme: componentTheme
    }, tab));
  })), /*#__PURE__*/React.createElement("section", {
    "aria-live": "polite",
    "aria-labelledby": "".concat(id, "_tabheader_").concat(activeTabIndex)
  }, tabPanel));
};

FilterTabs.displayName = 'FilterTabs';
export default FilterTabs;